import styled from 'styled-components';
import Text from './Text';
import AddRoundedIcon from '@mui/icons-material/AddRounded';

const Container = styled.div`
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border-radius: 20px;
  border: 1px solid ${({ theme }) => theme.colors.neutral[400]};
  cursor: pointer;
  align-self: flex-start;
  margin-top: 16px;
  gap: 4px;
`;
const PlusIcon = styled(AddRoundedIcon)`
  color: ${(props) => props.theme.colors.text.alternative};
`

const AddMeaningChip = ({ label, onAdd }) => (
  <Container onClick={onAdd}>
    <PlusIcon sx={{ fontSize: 20 }}/>
    <Text variant="body2">{label}</Text>
  </Container>
);

export default AddMeaningChip;
